export default "__VITE_ASSET__CyZb4K_z__"